import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Escuela1 from "../../../images/modulo14/escuela1.png";
import Escuela2 from "../../../images/modulo14/escuela2.png";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[11];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo14.url}/cierre`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[10].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[10].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>La escuela y las lenguas</strong>
            </h4>
            <p className="mt-1">
              Durante mucho tiempo, en las escuelas peruanas solo se enseñaba en
              castellano. Esto era muy <strong>injusto</strong> para los niños y
              niñas que no hablaban esta lengua.
            </p>
          </div>
          <div className="col-md-4">
            <img
              src={Escuela1}
              className="bg-white img-fluid rounded"
              alt="Escuela"
            />
          </div>
          <div className="col-md-3">
            <img
              src={Escuela2}
              className="bg-white img-fluid rounded"
              alt="Escuela"
            />
          </div>
          <div className="col-md-9 p-md-3 p-0">
            <p>
              Afortunadamente, hace ya varios años que existe la{" "}
              <strong>educación bilingüe</strong> en muchos departamentos del
              país. Así, en Ucayali, por ejemplo, hay escuelas donde se enseña
              en castellano pero también en shipibo-konibo.
            </p>
            <p>
              Para ello, se han elaborado <strong>alfabetos</strong> para las
              lenguas que no los tenían y se han hecho{" "}
              <strong>textos escolares</strong> en lenguas originarias. Además,
              es una gran oportunidad para que las lenguas se sigan usando y no
              se pierdan.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen las ilustraciones del texto titulado La escuela y
            las lenguas. Pregunte qué ven. Las ilustraciones muestran una
            escuela en la selva y a Eli enseñando diferentes textos en quechua.
            Pida que lean, en voz alta, el texto que aprece en el texto.
          </li>
          <li>
            Pregunte por qué resulta importante que exista la educación
            bilingüe. Cierre la sesión comentando que la educación bilingüe
            apareció ante la necesidad de un nuevo tipo de educación que
            reconociera la diversidad cultural y lingüística del Perú.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
